import { useTranslation } from "react-i18next";
import { ScrollArea, ScrollBar } from "@/components/atomic/ScrollArea";
import VocCard from "@/components/ui/VocCard";
import { cn } from "@/lib/utils";
import { Voc } from "@/models/Voc";

interface Props {
  className?: string;
  vocs: Voc[];
  title?: string;
  innerScrollable?: boolean;
  hasMore?: boolean;
  isLoading?: boolean;
  onLoadMore?: () => void;
  visibleAttributeNames?: string[];
  headerContent?: React.ReactNode;
}

const VocsView: React.FC<Props> = (
  {
    className = "",
    vocs,
    title,
    innerScrollable,
    hasMore = false,
    isLoading = false,
    onLoadMore = () => {},
    visibleAttributeNames,
    headerContent,
  },
) => {
  const { t } = useTranslation("voiceek_ui");

  const renderVocs = () => (
    <div className={cn("flex flex-col gap-2 mt-2", innerScrollable && "mr-[14px]")}>
      {vocs.map((voc, _) => <VocCard key={voc.id} voc={voc} visibleAttributeNames={visibleAttributeNames} />)}
    </div>
  );

  return (
    <div className={cn("h-full flex flex-col min-h-0", className)}>
      <div className="w-full h-[30px] px-[10px] font-bold text-white bg-[#293d72] rounded-[5px] leading-[30px] mb-2">
        {title ?? t("analysis.voc.title")}
      </div>
      {headerContent && <div className="mt-2 mb-2">{headerContent}</div>}
      {innerScrollable
        ? (
          <ScrollArea className="h-full">
            {renderVocs()}
            {/* ページング関連のUI */}
            {hasMore && (
              <div className="text-center">
                <button className="mt-[8px] text-[#6888e1] cursor-pointer" onClick={onLoadMore}>
                  {isLoading ? "読み込み中..." : "もっと見る"}
                </button>
              </div>
            )}
            <ScrollBar orientation="vertical" />
          </ScrollArea>
        )
        : (
          <>
            {renderVocs()}
          </>
        )}
    </div>
  );
};

export default VocsView;
